import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const DyelotCell = ({item, bgColor}) => {
  return (
    <Box sx={{pb: 4, display: 'flex', alignItems: 'flex-start'}}>
      {/* Status Dot */}
      <Box
        sx={{
          height: 10,
          width: 10,
          mr: 3,
          mt: 1.2,
          borderRadius: '50%',
          backgroundColor: bgColor,
          flexShrink: 0,
        }}
      />

      <Box sx={{flexGrow: 1}}>
        <Box sx={{display: 'flex', justifyContent: 'space-between', mb: 1}}>
          <Typography sx={{fontSize: 13, fontWeight: 'medium'}}>
            {item.name}
          </Typography>
          <Typography sx={{fontSize: 13, fontWeight: 'bold'}}>
            {item.count}
          </Typography>
        </Box>

        {/* Dye Lot Tags - Compact for Column Layout */}
        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
          {item.dyeLots.map((lot) => (
            <Box
              key={lot}
              sx={{
                fontSize: 10,
                px: 1.5,
                py: 0.2,
                borderRadius: '4px',
                backgroundColor: '#f5f7fa',
                color: '#718096',
                border: '1px solid #e2e8f0',
              }}
            >
              {lot}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

DyelotCell.propTypes = {
  item: PropTypes.object,
  bgColor: PropTypes.string.isRequired,
};

export default DyelotCell;
